/**
 * The two states (rules: shared data/combat.ts): a small glass badge "ต่อสู้ 7" with the seconds left while the player is in
 * combat; gone when out. Hidden during a bout (the duel HUD owns the screen then). Phones: smaller, tucked up to the top edge.
 */
import { combatSecondsLeft, type World } from '@nine/shared';
import { h } from './dom';

const CSS = `
.combat-badge{position:fixed;top:max(46px,calc(env(safe-area-inset-top) + 40px));left:50%;transform:translateX(-50%);z-index:5;
display:flex;gap:8px;align-items:baseline;padding:3px 12px;border-radius:6px;pointer-events:none;white-space:nowrap;
background:rgba(22,19,15,.78);border:1px solid rgba(208,69,47,.7);color:#ffd9cf;font:700 14px/1.3 var(--f-ui,sans-serif);
text-shadow:0 1px 1px rgba(0,0,0,.6)}
.combat-badge b{font-size:16px;min-width:1.2em;text-align:right;color:#f4f1ea}
@media (max-width:900px),(max-height:500px){.combat-badge{top:max(4px,env(safe-area-inset-top));padding:2px 8px;font-size:12px}.combat-badge b{font-size:13px}}
`;

export class CombatBadge {
  readonly el = h('div', { class: 'combat-badge' });
  private readonly num = h('b');
  private left = -1;

  constructor() {
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.append(style);
    this.el.append(h('span', {}, 'ต่อสู้'), this.num);
    this.el.hidden = true;
    document.body.append(this.el);
  }

  /** Each frame; only touches the DOM when the whole second changes. */
  sync(w: World): void {
    const n = w.duel || w.player.dead ? 0 : combatSecondsLeft(w.player);
    if (n === this.left) return;
    this.left = n;
    this.el.hidden = n === 0;
    this.num.textContent = String(n);
  }
}
